<template src='./role-create.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import { EventBus } from '@/router/bus'
import { required, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'

export default {
  components: {
    ContextPage
  },
  mixins: [validationMixin],
  data () {
    return {
      role: {
        name: '',
        description: '',
        claims: []
      },
      help: {
        create: Vue.$helpConfig.roleCreate
      },
      claims: [],
      dialog: false,
      formValid: true,
      loading: false,
      nameRules: [
        v => !!(v.trim()) || this.$t('validation.usernameRequired'),
        v => (v && v.length <= 32) || this.$t('validation.usernameTooLong')
      ],
      descriptionRules: [
        v => (v.length <= 128) || this.$t('validation.usernameTooLong')
      ]
    }
  },
  created () {
    this.retrieveAvailableClaims()
  },
  computed: {
    nameErrors () {
      return this.getValidationErrorsByName('name')
    },
    descriptionErrors () {
      return this.getValidationErrorsByName('description')
    }
  },
  methods: {
    retrieveAvailableClaims () {
      this.loading = true
      this.$http.get(Vue.$apiConfig.availableClaimsGet).then(
        response => {
          this.logConsole(response)
          this.claims = response.data.payload
          this.loading = false
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        }
      )
    },
    validateBeforeRoleSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.openDialog()
    },
    addRole () {
      this.loading = true
      this.dialog = false
      this.$http.post(Vue.$apiConfig.createRolePost, this.role).then(
        response => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('userAdministration.createRoleSuccessful'),
            errors: []
          })
          this.loading = false
          this.dialog = false
          this.resetRole()
          this.$router.push('/administration/role/management')
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        })
    },
    openDialog () {
      if (!this.$refs.form.validate()) {
        this.scrollToForm()
        return
      }
      if (this.role.claims.length === 0) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('validation.claimRequired'),
          errors: []
        })
        return
      }
      this.dialog = true
    },
    resetRole () {
      this.role = {
        name: '',
        description: '',
        claims: []
      }
      this.$refs.form.resetValidation()
    },
    getValidationErrorsByName (name) {
      if (!this.$v.role[name].$dirty) return []
      return this.getValidationErrors('role').filter((x) => { return x.field === name }).map(x => x.msg)
    }
  },
  validations () {
    const rules = {}

    Object.assign(rules, {
      name: {
        required,
        maxLength: maxLength(32)
      },
      description: {
        required,
        maxLength: maxLength(128)
      }
    })

    return {
      role: rules
    }
  }
}
</script>
